import shortid from 'shortid'

/**
 * Local-only transform: fallback when the livedemos integration is not
 * available. Keeps the original external image URL (may be CORS-blocked
 * when rendered).
 */
export function localTransformProducts(products) {
  return products.map((product) => ({
    id: product.id || shortid(),
    sku: product.sku,
    name: product.name,
    description: product.description,
    price: product.price,
    currency: product.currency,
    image: product.image,
    category:
      product.categories && product.categories.length > 0 ? product.categories.join(', ') : null,
  }))
}

/**
 * Map a livedemos-ingested product to Argon's product shape.
 */
export function transformLivedemosProduct(product, fallbackImage = null) {
  return {
    id: product.id || shortid(),
    sku: product.sku,
    name: product.name,
    description: product.description,
    price: product.price,
    currency: product.currency,
    image: fallbackImage,
    category:
      product.categories && product.categories.length > 0
        ? product.categories.find((c) => c && !c.includes(' ')) || product.categories[0]
        : null,
  }
}
